import { ISourceDataConfigurationEvent } from "@/api/dtos";
import { ISelectionOption, IUpdateMapping, updateBySelection } from ".";

export const ConfigurationUpdateEventMapping: IUpdateMapping = {
    createOptions: (source, target) => {
        let options: ISelectionOption[] = [
            {
                name: 'options',
                label: 'Options',
                options: [
                    {
                        name: 'overrideName',
                        label: 'Override Name',
                        update: (source, target, sourceValue, targetValue, newValue) => {
                            (newValue as ISourceDataConfigurationEvent).name = (sourceValue as ISourceDataConfigurationEvent).name;
                        }
                    },
                    {
                        name: 'priority',
                        label: 'Priority',
                        update: (source, target, sourceValue, targetValue, newValue) => {
                            (newValue as ISourceDataConfigurationEvent).priority = (sourceValue as ISourceDataConfigurationEvent).priority;
                        }
                    },
                    {
                        name: 'excludeBlank',
                        label: 'Hide Event When No Data Provided',
                        update: (source, target, sourceValue, targetValue, newValue) => {
                            (newValue as ISourceDataConfigurationEvent).excludeBlank = (sourceValue as ISourceDataConfigurationEvent).excludeBlank;
                        }
                    },
                    {
                        name: 'alerts',
                        label: 'Alerts',
                        options: [
                            {
                                name: 'information',
                                label: 'Information',
                                update: (source, target, sourceValue, targetValue, newValue) => {
                                    (newValue as ISourceDataConfigurationEvent).alertInformation = (sourceValue as ISourceDataConfigurationEvent).alertInformation;
                                }
                            },
                            {
                                name: 'warning',
                                label: 'Warning',
                                update: (source, target, sourceValue, targetValue, newValue) => {
                                    (newValue as ISourceDataConfigurationEvent).alertWarning = (sourceValue as ISourceDataConfigurationEvent).alertWarning;
                                }
                            },
                            {
                                name: 'error',
                                label: 'Error',
                                update: (source, target, sourceValue, targetValue, newValue) => {
                                    (newValue as ISourceDataConfigurationEvent).alertError = (sourceValue as ISourceDataConfigurationEvent).alertError;
                                }
                            },
                            {
                                name: 'success',
                                label: 'Success',
                                update: (source, target, sourceValue, targetValue, newValue) => {
                                    (newValue as ISourceDataConfigurationEvent).alertSuccess = (sourceValue as ISourceDataConfigurationEvent).alertSuccess;
                                }
                            }
                        ]
                    },
                    {
                        name: 'discrepancyNotes',
                        label: 'Discrepancy Notes',
                        options: [
                            {
                                name: 'showNotes',
                                label: 'Show Discrepancy Notes',
                                update: (source, target, sourceValue, targetValue, newValue) => {
                                    (newValue as ISourceDataConfigurationEvent).showNotes = (sourceValue as ISourceDataConfigurationEvent).showNotes;
                                }
                            },
                            {
                                name: 'types',
                                label: 'Types',
                                update: (source, target, sourceValue, targetValue, newValue) => {
                                    (newValue as ISourceDataConfigurationEvent).noteTypes = (sourceValue as ISourceDataConfigurationEvent).noteTypes;
                                }
                            },
                            {
                                name: 'statuses',
                                label: 'Statuses',
                                update: (source, target, sourceValue, targetValue, newValue) => {
                                    (newValue as ISourceDataConfigurationEvent).noteStatuses = (sourceValue as ISourceDataConfigurationEvent).noteStatuses;
                                }
                            }
                        ]
                    }
                ]
            }
        ];

        return options;
    },
    update: (source, target, sourceValue, targetValue, options, selection) => {
        const newValue = { 
            ...targetValue
        };

        updateBySelection(source, target, sourceValue, targetValue, newValue, options, selection);

        return newValue;
    }
}